"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeKeeper = exports.truncateByWordCount = exports.coalesceHoldingsByTickerSymbol = exports.urlWithQueryString = exports.toQueryString = exports.validateHeaderForJWT = exports.withRetry = void 0;
const lodash_1 = require("lodash");
const withRetry = async (func, toRetryCheck, opts) => {
    const options = {
        functionName: opts === null || opts === void 0 ? void 0 : opts.functionName,
        attempts: (opts === null || opts === void 0 ? void 0 : opts.attempts) || 5,
        backoffMultiplier: (opts === null || opts === void 0 ? void 0 : opts.backoffMultiplier) || 1.8,
    };
    let currentResp = await func();
    let backoff = 1;
    for (let i = 0; i < options.attempts; i++) {
        const toRetry = toRetryCheck(currentResp);
        if (!toRetry) {
            return currentResp;
        }
        console.log(`Waiting ${backoff} second(s) to retry`, options.functionName ? `"${options.functionName}"` : "");
        await new Promise((resolve) => setTimeout(() => resolve(true), backoff * 1000));
        backoff = backoff * options.backoffMultiplier;
        currentResp = await func();
    }
    return currentResp;
};
exports.withRetry = withRetry;
function validateHeaderForJWT(req, jwt) {
    const authString = req.headers.authorization;
    if (!authString) {
        return {
            error: {
                errorMessage: "No auth string provided",
                body: undefined,
            },
        };
    }
    const splitAuthString = authString.split(" ");
    if (splitAuthString.length !== 2) {
        return {
            error: {
                errorMessage: "Auth string does not contain two parts",
                body: undefined,
            },
        };
    }
    if (splitAuthString[0].toLowerCase() !== "bearer") {
        return {
            error: {
                errorMessage: "Auth string is not following Bearer format",
                body: undefined,
            },
        };
    }
    const providedJwt = splitAuthString[1];
    return {
        response: providedJwt === jwt,
    };
}
exports.validateHeaderForJWT = validateHeaderForJWT;
function toQueryString(params, keysToFilter = []) {
    const stringifiedParams = Object.entries(params || {})
        .filter(([k]) => !keysToFilter.includes(k))
        .map(([k, v]) => [k, (v === null || v === void 0 ? void 0 : v.toString()) || ""])
        .sort(); // sort for predictable order to ease testing
    return new URLSearchParams(stringifiedParams).toString();
}
exports.toQueryString = toQueryString;
function urlWithQueryString(baseUrl, queryParams, keysToFilter = []) {
    return [baseUrl, toQueryString(queryParams, keysToFilter)]
        .filter((v) => v.length > 0)
        .join("?");
}
exports.urlWithQueryString = urlWithQueryString;
const coalesceHoldingsByTickerSymbol = (holdings) => {
    const holdingsWithoutTickerSymbol = holdings.filter((h) => !h.tickerSymbol);
    const unGroupedHoldings = holdingsWithoutTickerSymbol.map((h) => {
        const holding = {
            name: h.name,
            tickerSymbol: h.tickerSymbol,
            latestPrice: (h.value || 0) / (h.quantity || 1),
            totalQuantity: h.quantity || null,
            hasAvailablePerks: h.hasAvailablePerks,
            certificateId: h.certificateId,
        };
        return holding;
    });
    const holdingsWithTickerSymbol = holdings.filter((h) => h.tickerSymbol);
    const holdingByTickerSymbol = (0, lodash_1.groupBy)(holdingsWithTickerSymbol, "tickerSymbol");
    const coalescedHoldings = Object.values(holdingByTickerSymbol).map((h) => {
        const name = h[0].name;
        const tickerSymbol = h[0].tickerSymbol;
        const latestPrice = (h[0].value || 0) / (h[0].quantity || 1);
        const certificateId = h[0].certificateId;
        let totalQuantity = null;
        h.forEach((h) => {
            if (totalQuantity == null && (h === null || h === void 0 ? void 0 : h.quantity)) {
                totalQuantity = h === null || h === void 0 ? void 0 : h.quantity;
            }
            else if (totalQuantity !== null && (h === null || h === void 0 ? void 0 : h.quantity)) {
                totalQuantity += h === null || h === void 0 ? void 0 : h.quantity;
            }
        });
        return {
            name,
            tickerSymbol,
            latestPrice,
            totalQuantity,
            hasAvailablePerks: (0, lodash_1.some)(h, (holding) => holding.hasAvailablePerks),
            certificateId,
        };
    });
    return [...coalescedHoldings, ...unGroupedHoldings];
};
exports.coalesceHoldingsByTickerSymbol = coalesceHoldingsByTickerSymbol;
function truncateByWordCount(value, wordCount = 40, ending = "...") {
    if (value) {
        const wordArray = value.split(" ");
        if (wordArray.length > wordCount) {
            return `${wordArray.slice(0, wordCount).join(" ")}${ending}`;
        }
        else {
            return value;
        }
    }
    return null;
}
exports.truncateByWordCount = truncateByWordCount;
class TimeKeeper {
    constructor() {
        this.segments = [];
    }
    addTime() {
        this.segments = [...this.segments, new Date()];
    }
    printTimes() {
        this.segments.forEach((segment, i) => {
            if (this.segments.indexOf(segment) === this.segments.length - 1) {
                return;
            }
            const nextSegment = this.segments[i + 1];
            console.log("Step", i + 1, nextSegment.getTime() - segment.getTime());
        });
    }
}
exports.TimeKeeper = TimeKeeper;
//# sourceMappingURL=utils.js.map